export const getDaysRemaining = (startDate) => {
  const start = new Date(startDate);
  const end = new Date(start);
  end.setFullYear(end.getFullYear() + 5);

  const today = new Date();

  const diffTime = end.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : 0;
};

const formatDate = (date) => {
    const day = date.getDate();
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    // const year = date.getFullYear().toString().slice(-2);
    const year = date.getFullYear().toString();
    return `${day} ${month} ${year}`;
  }

export default formatDate;

const URL_REGEX = /(https?:\/\/[^\s<>"']+)/g;

/**
 * Splits a line of text into plain strings and <a> elements for URLs.
 * Safe — no dangerouslySetInnerHTML.
 */
export const linkify = (text) => {
  if (!text) return null;
  const parts = text.split(URL_REGEX);
  return parts.map((part, i) => {
    if (URL_REGEX.test(part)) {
      // Reset lastIndex after test()
      URL_REGEX.lastIndex = 0;
      let display;
      try {
        const u = new URL(part);
        display = u.hostname + (u.pathname !== '/' ? u.pathname : '');
      } catch (_) {
        display = part;
      }
      return (
        <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="nd-inline-link">
          {display}
        </a>
      );
    }
    URL_REGEX.lastIndex = 0;
    return part;
  });
};